(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lifestyle-carousel"] && !Shopify.designMode) return;
  try {
    
  const lifestyleCarousel = document.querySelector('[js-lifestyle-carousel="swiper"]');

  if (!lifestyleCarousel) {
    return;
  }
  
  const lifestyleCarouselSwiper = new Swiper(lifestyleCarousel, {
    slidesPerView: 1.1,
    spaceBetween: 10,
    breakpoints: {
      750: {
        slidesPerView: 3.2,
        spaceBetween: 20
      }
    },
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  } catch(e) { console.error(e); }
})();
})();
